import { createSlice } from "@reduxjs/toolkit";

const trialSlice = createSlice({
  name: "trial",
  initialState: {
    noTrialActive: undefined,
    trialFeeWaived: undefined,
    trialFee: undefined,
    hasTrialFee: undefined,
  },
  reducers: {
    updateTrialFromServerContext: {
      reducer: (state, action) => {
        return Object.assign({}, state, action.payload);
      },
      prepare: (serverContext) => {
        let trialFee = 0;
        if (serverContext?.plans?.[4]) {
          trialFee = serverContext.plans[4].trial_fee;
        } else if (serverContext?.plan) {
          trialFee = serverContext.plan.trial_fee;
        }
        return {
          payload: {
            trialFee,
            noTrialActive: serverContext.no_trial_active,
            trialFeeWaived: serverContext.trial_fee_waived,
            hasTrialFee: !serverContext.trial_fee_waived && trialFee > 0,
          },
        };
      },
    },
  },
});

const { actions, reducer } = trialSlice;

export const { updateTrialFromServerContext } = actions;

export default reducer;
